// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var ApiConfigurationsList$ReactHooksTemplate = require("./apiConfigurationsList.res.js");

function WhatsAppChannel(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: "WhatsApp",
                      className: "px-5 py-6 border-b border-gray-300 text-darkcharcoal font-bold text-xl"
                    }),
                JsxRuntime.jsx("div", {
                      children: "Active configurations can be selected on campaign WhatsApp modes. Several may be active at once. Deactivate a configuration to stop sending on campaigns that use it. Delete is only allowed when no campaign uses it.",
                      className: "px-5 pt-4 text-sm text-aurometalsaurus"
                    }),
                JsxRuntime.jsx(ApiConfigurationsList$ReactHooksTemplate.make, {
                      apiType: "WhatsApp"
                    })
              ]
            });
}

var make = WhatsAppChannel;

exports.make = make;
/* react/jsx-runtime Not a pure module */
